import React, { useState, useCallback, useEffect } from 'react';
import { styled, Row, Col } from '@teko/ui';
import { ShowMoreBtn } from './ShowMoreBtn.es.js';
import { SelectOption } from '../../../Common/SelectOption/SelectOption.es.js';

const Title = styled.div`
  font-weight: 600;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
const StyledOption = styled(SelectOption)((props) => `
    margin-right: 0.5rem;
    margin-bottom: 0.3rem;
    padding: 0.375rem 1.25rem;
    color: ${props.isActive ? props.theme.brand.primary : "#333"};
    cursor: pointer;
    &:hover {
      background: #f3f3f3;
    }
  `);
const StyledRow = styled(Row)`
  margin-bottom: 0.25rem;
  margin-left: 0;
  margin-right: 0;
  > * {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;
const StyledShowMoreBtn = styled(ShowMoreBtn)`
  margin-top: 0.3rem;
  float: right;
`;
const ListOption = styled(Col)`
  height: ${(props) => props.isShowMore ? "auto" : "2.5rem"};
  overflow: hidden;
`;
const FilterRow = ({
  value,
  filter,
  onClickOption
}) => {
  const [isShowMore, setIsShowMore] = useState(false);
  const [isHideButtonShowMore, setIsHideButtonShowMore] = useState(false);
  const isSelected = useCallback((filterValue) => {
    if (!value) {
      return false;
    }
    return !!~value.split(",").indexOf(filterValue.optionCode);
  }, [value]);
  useEffect(() => {
    var _a;
    const height = ((_a = document.getElementById(`js-${filter.code}`)) == null ? void 0 : _a.clientHeight) || 0;
    if (height < 90) {
      setIsHideButtonShowMore(true);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, {
    col: 1.5
  }, /* @__PURE__ */ React.createElement(Title, null, filter.name)), /* @__PURE__ */ React.createElement(ListOption, {
    isShowMore,
    col: 10
  }, /* @__PURE__ */ React.createElement("div", {
    id: `js-${filter.code}`
  }, filter.options.map((option, index) => /* @__PURE__ */ React.createElement(StyledOption, {
    activeBackground: "#fff",
    isActive: isSelected(option),
    onClickOption: () => onClickOption && onClickOption(option),
    key: index,
    stickySize: "sm"
  }, option.optionName)))), /* @__PURE__ */ React.createElement(Col, {
    col: 0.5
  }, !isHideButtonShowMore && /* @__PURE__ */ React.createElement(StyledShowMoreBtn, {
    isActive: isShowMore,
    setIsActive: setIsShowMore
  })));
};

export { FilterRow };
